module.exports = __webpack_public_path__ + "img/org_bg.3dbd5d6a.png";